import React from "react";

// Decorative fiber-optic strands with traveling light pulses,
// placed under the "DALLA SFIDA" accent to evoke network connection.
export default function FiberStrands({ className = "" }) {
  const paths = [
    "M0 18 C 60 4, 120 30, 190 16 S 320 6, 400 18",
    "M0 24 C 70 34, 150 10, 230 26 S 340 34, 400 22",
    "M0 12 C 80 18, 160 2, 250 14 S 360 20, 400 10",
  ];
  const colors = ["#f5c542", "#ff7a1a", "#e60000"];
  return (
    <svg
      className={className}
      viewBox="0 0 400 36"
      fill="none"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      {paths.map((d, i) => (
        <g key={i}>
          <path d={d} stroke={colors[i]} strokeWidth="1.2" opacity="0.55" className="fiber-strand" style={{ animationDelay: `${i * 0.4}s` }} />
          <circle r="2.4" fill="#fff">
            <animateMotion dur={`${2.6 + i * 0.7}s`} begin={`${i * 0.5}s`} repeatCount="indefinite" path={d} />
            <animate attributeName="opacity" values="0;1;1;0" dur={`${2.6 + i * 0.7}s`} begin={`${i * 0.5}s`} repeatCount="indefinite" />
          </circle>
        </g>
      ))}
    </svg>
  );
}
